import JobStatus from "@/models/Jobs/JobStatus";

export default class FilterJobsRequest {
    status: JobStatus = JobStatus.Open;
    branchId = '';
    deskId = '';
    companyId = '';
    locationId = '';
    latitude = 0;
    longitude = 0;
    distance = 0;
    ownerId = '';
    annualSalary = 0;
    positionCodes: string[] = [];
    includeSecondaryPositions = false;
    skillCodes: string[] = [];
    qualificationCodes: string[] = [];
}